export default (context:any, payload:any) => {
    const appState = context.rootState.appState;
    const moduleId = context.getters.moduleId;
    if (context.rootState[`${moduleId}_errors`].errors.length) {
        return;
    }

    const hoursState = context.rootState[`${moduleId}_hours`];
    const hours = hoursState.options.find((opt: { value:string })  => opt.value === hoursState.value)?.value;

    const minutesState = context.rootState[`${moduleId}_minutes`];
    const minutes = minutesState.options.find((opt : { value:string }) => opt.value === minutesState.value)?.value;

    const quantity = `${Number(context.rootState[`${moduleId}_quantity`].value)}`;

    const value = {
        ...appState.selectedJob,
        hours,
        minutes,
        quantity,
    };

    const index = appState.editIndex;
    if (index === null) { // Add
        context.commit('appState/UPDATE_JOB_PLAN', { value }, { root: true });
    } else { // Update
        context.commit('appState/UPDATE_JOB_PLAN', {
            value,
            index,
        }, {
            root: true,
        });
    }

    context.dispatch(`${moduleId}_job-plan-table/updateTable`, {
        oneLni: payload.oneLni,
    }, {
        root: true,
    }).then(() => {
        context.dispatch(`${moduleId}/clear`, payload, { root: true });
        context.dispatch(`${moduleId}/displayNotification`, payload, { root: true });
        context.commit('appState/SET_VALUE', {
            key: 'selectedJob',
            value: null,
        }, {
            root: true,
        });
    });
};